import * as React from "react";
import Box from "@amzn/awsui-components-console/box";
import SpaceBetween from "@amzn/awsui-components-console/space-between";

interface TableWithNoDataPropType {
    message?: string;
    actionButton?: React.ReactNode;
}

/**
 * Use this component to display message if there is no data
 * which to populate the table or the data has finished loading.
 */
export function TableWithNoData({
  message,
  actionButton,
}: TableWithNoDataPropType): React.ReactElement {
    return (
        <div>
            <Box
                textAlign="center"
                margin={{ bottom: "xxs" }}
                padding={{ top: "xxs" }}
            >
                <SpaceBetween direction="vertical" size="m">
                    <h3>{message}</h3>
                    {actionButton && actionButton}
                </SpaceBetween>
            </Box>
        </div>
    );
}